import { render } from "./NotificationsContent.vue?vue&type=template&id=738398c0&scoped=true&ts=true"
import script from "./NotificationsContent.vue?vue&type=script&lang=ts"
export * from "./NotificationsContent.vue?vue&type=script&lang=ts"

import "./NotificationsContent.vue?vue&type=style&index=0&id=738398c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738398c0"]])

export default __exports__